
import { BackgroundEffect, BackgroundContext } from './BackgroundEffect';

export abstract class BaseBackgroundEffect implements BackgroundEffect {
    public abstract render(bc: BackgroundContext): void;

    protected getPrimaryColor(bc: BackgroundContext): string {
        if (bc.config.backgroundRainbowMode) {
            return `hsl(${bc.globalHue % 360}, 70%, 50%)`;
        }
        return bc.config.backgroundPrimaryColor;
    }

    protected getSecondaryColor(bc: BackgroundContext): string {
        if (bc.config.backgroundRainbowMode) {
            return `hsl(${(bc.globalHue + 120) % 360}, 70%, 30%)`;
        }
        return bc.config.backgroundSecondaryColor;
    }

    protected getTertiaryColor(bc: BackgroundContext): string {
        if (bc.config.backgroundRainbowMode) {
            return `hsl(${(bc.globalHue + 240) % 360}, 70%, 20%)`;
        }
        return bc.config.backgroundTertiaryColor;
    }
}
